/** Cookie names that identify the user and may exist on both host-only and Domain=.netgear.com. */
const IDENTITY_COOKIE_NAMES = ['user_email', 'userId', 'userid', 'email'];

/**
 * Removes identity cookies across host-only and `.netgear.com` scopes.
 * Without this, a cookie from production (Domain=.netgear.com) can coexist with local-dev cookies
 * and APIs may see the wrong user_email / userId (QA: duplicate user_email until manual delete).
 *
 * @param {import('universal-cookie').default} cookieJar - universal-cookie instance.
 */
export function clearIdentityCookiesAllScopes(cookieJar) {
  const secure = process.env.secureCoockie;
  const pathOpts = { path: '/', secure };
  for (const name of IDENTITY_COOKIE_NAMES) {
    cookieJar.remove(name);
    cookieJar.remove(name, pathOpts);
    cookieJar.remove(name, { domain: '.netgear.com' });
    cookieJar.remove(name, { path: '/', domain: '.netgear.com' });
  }
}
